import { Image, useComputedColorScheme } from '@mantine/core';
import logoLight from '../assets/transpay-logo-light.png';
import logoDark from '../assets/transpay-logo-dark.png';

/**
 * TransPay wordmark. Swaps between the dark-text variant (for light UI) and the
 * light-text variant (for dark UI) so the logo always reads against the current
 * color scheme. The artwork is a transparent PNG, so it sits on any background.
 */
export function Logo({ height = 28 }: { height?: number | string }) {
  const scheme = useComputedColorScheme('light', { getInitialValueInEffect: true });
  return (
    <Image
      src={scheme === 'dark' ? logoDark : logoLight}
      alt="TransPay"
      h={height}
      w="auto"
      // Never let the wordmark overflow its container on narrow viewports.
      maw="100%"
      fit="contain"
    />
  );
}
